<template>
  <div>
    <div class="loan-table">
      <!--设计稿高度为500px，这里底层页面的高度没那么高，会溢出-->
      <el-table class="table-body pointer" :data="loanListData" @row-click="toLoanDetail">
        <el-table-column type='index' label="序号" width="65">
          <template slot-scope="scope">
            <i v-if="scope.row.signCount||scope.row.payCount > 0"  class="red-point-tip5"></i>
            <span class="item_index">
              {{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="applyCode" label="申请编号" width="90" show-overflow-tooltip></el-table-column>
        <!--新增产品名称-->
        <el-table-column prop="productName" label="产品名称" width="90" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column class-name="front-apply-money" prop="expectTransferAmount" :formatter="formatMoney" label="借款金额"
                         width="110"></el-table-column> -->
        <el-table-column class-name="front-apply-money" label="融资金额" width="115">
          <template slot-scope="scope">
            <span style="color:#EB662B;">¥{{scope.row.expectTransferAmount | addThousandSign(2)}}</span>
          </template>
        </el-table-column>
        <!--新增产品名称-->
        <el-table-column class-name="front-apply-money" label="应收账款转让金额" width="200">
          <template slot-scope="scope">
            <span style="color:#EB662B;">¥{{scope.row.forecastReceAmount | addThousandSign(2)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行" width="100" :formatter="formatBankName" show-overflow-tooltip></el-table-column>
        <el-table-column prop="applyDate" label="融资申请日期" width="125" format="yyyy-MM-dd"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope" style="position: relative;">
            <span @click.stop="slotDialog(scope)" class="business_button">{{scope.row.applyStateName}}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 步骤弹框 -->
      <el-dialog title="当前业务进度" :visible.sync="stepShow" width="30%" :before-close="handleClose">
        <div class="busineStep">
          <el-steps :active="stepActive" align-center>
            <el-step title="步骤1" description=""></el-step>
            <el-step title="步骤2" description=""></el-step>
            <el-step title="步骤3" description=""></el-step>
            <el-step title="步骤4" description=""></el-step>
            <el-step title="步骤5" description=""></el-step>
          </el-steps>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stepShow = false">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 进度条 -->
      <el-pagination class="pament-list-pagination" :small="isSmall" :total="frontApplyCount" layout="prev, pager, next" :page-size="pageSize" style="text-align: center;" @current-change="changePage" v-show="frontApplyCount > 1">
      </el-pagination>
    </div>
    <confirm-modal :show="isDeleteLoanItemFrontApply" content="是否确定删除该条借款？" @confirm-click="deleteLoanItem" @cancel-click="isDeleteLoanItemFrontApply = false"></confirm-modal>
    <!--<div class="block">-->
    <!--&lt;!&ndash;<span class="demonstration">页数较少时的效果</span>&ndash;&gt;-->
    <!--<span class="page_num" @click="pageNumClick(item)" v-for="(item,index) in pageArr" :key="index">{{item}}</span>-->
    <!--</div>-->
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import _ from 'lodash';
import confirmModal from '../common/Confirm.vue';
import MyLoanApi from '../../api/myloan_bl.js';
import axios from 'axios';
export default {
  data() {
    return {
      stepActive: 5,
      isSmall: true,
      stepShow: false,
      isDeleteLoanItemFrontApply: false,
      frontApplyId: '',
      itemApplyId: '',
      loanAction: {
        editText: '编辑',
        deleteText: '删除'
      },
      loanListData: [],
      frontApplyCount: 0,
      states: 'all', // 筛选数据
      pageNum: 1, // 初始化页码
      pageSize: 8,
      pageArr: []
    };
  },
  components: {
    confirmModal
  },
  computed: {
    ...mapGetters({
      activeName: types.ACTIVE_NAME,
      userInfo: types.GET_USER,
      pageCurrent: types.PAGE_CURRENT,
      frontApplyState: types.FRONT_APPLY_STATE,

      // loanListData: types.LOAN_LIST_DATA,
      pageCount: types.PAGE_COUNT
    })
  },
  methods: {
    ...mapMutations({
      setFrontApplyState: types.SET_FRONT_APPLY_STATE,
      setActiveName: types.SET_ACTIVE_NAME,
      setFrontItemApplyState: types.SET_FRONT_ITEM_STATE_FRONT
    }),
    ...mapActions({
      getLoanListData: types.GET_MY_LOAN_LISTS_DATA,
      getPageCurrent: types.GET_PAGE_CURRENT,
      deleteLoanItemFrontApply: types.DELETE_LOAN_ITEM_FRONT_APPLY,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    // 符号
    formatMoney(obj) {
      const num = Number(obj.expectTransferAmount);
      let fmNum = !_.isNaN(num) ? (`${num.toFixed(0)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : '';
      fmNum = `￥${fmNum}`;
      return fmNum;
    },
    formatMoneyAll(obj) {
      const num = Number(obj.forecastReceAmount);
      let fmNum = !_.isNaN(num) ? (`${num.toFixed(0)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : '';
      fmNum = `￥${fmNum}`;
      return fmNum;
    },
    formatBankName(obj){
        const bankName = obj.bankName;
        if(bankName.indexOf("-")>0){
          var bankNameArr = bankName.split("-");
          return bankNameArr[0]+"\n("+bankNameArr[1]+")";
        }else{
          return bankName;
        }
    },
    // 符号

    // 项目详情跳转现不跳转
    notoLoanDetail(row, event, column) {
      this.$router.push({ path: `/loanDetail_bl/${row.frontApplyId}` });
      const target = event.target;
      if (target.className !== 'disabled_btn') {
        this.setActiveName('2');
        this.setFrontItemApplyState(row.frontApplyState);
        this.$router.push({ path: `/loanDetail_bl/${row.frontApplyId}` }); // 我的保理详情页
      }
    },
    // 修改上面，跳转项目详情
    toLoanDetail(row, event, column) {
      if(row.applyState.indexOf("f2")!=-1 || row.applyState.indexOf("f3")!=-1 || row.applyState.indexOf("f4")!=-1){
          const query = {
            frontApplyId: row.frontApplyId,
            isEdit: true,
            yanse: 1,
            productName:row.productName
          };
          switch (row.applyState) {
            case 'f1':
              // 跳转第二步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step3_bak_bl`,
                query: {
                  ...query,
                  selectedBankcardId: row.bankAccountIds
                }
              });
              break;
            case 'f2':
              // 跳转第三步
              if(row.isReject == 1){
                this.$router.push({
                  path: `/applyLoan/`+row.productId+`/step2_bl`,
                  query: {
                    ...query,
                    selectedBankcardId: row.bankAccountIds
                  }
                });
              }else{
                this.$router.push({
                  path: `/applyLoan/`+row.productId+`/step3_bl`,
                  query: {
                    ...query,
                    selectedBankcardId: row.bankAccountIds
                  }
                });
              }
              break;
            case 'f3':
              // 跳转第四步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step4_bl`,
                query: {
                  ...query,
                  selectedBankcardId: row.bankAccountIds
                }
              });
              break;
            case 'f4':
              // 跳转第五步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step5_bl`,
                query
              });
              break;
            default:
              // 跳转第一步
              this.$router.push({
                path: `/applyLoan/`+row.productId+`/step2_bl`,
                query
              });
              break;
          }
      }else{
        this.$router.push({ path: `/loanDetail_bl/${row.frontApplyId}` });
      }
    },
    slotDialog(obj) {
      this.stepShow = true
      if(obj.row.applyState == 'f2'){
        this.stepActive = 2;
      }else if(obj.row.applyState == 'f3'){
        this.stepActive = 3;
      }else if(obj.row.applyState == 'f4'){
        this.stepActive = 4;
      }else{
        this.stepActive = 5;
      }
    },
    handleClose(done) {
      this.stepShow = false
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    toLoanEdit(row) {
      const query = {
        frontApplyId: row.frontApplyId,
        isEdit: true
      };
      switch (row.frontApplyState) {
        case 'f1':
          this.$router.push({
            path: `/applyLoan/${row.productId}/step2_bl`,
            query
          });
          break;
        case 'f2':
          this.$router.push({
            path: `/applyLoan/${row.productId}/step3_bl`,
            query: Object.assign(query, {
              selectedBankcardId: row.bankAccountId
            })
          });
          break;
        case 'f3':
          this.$router.push({
            path: `/applyLoan/${row.productId}/step4_bl`,
            query: Object.assign(query, {
              selectedBankcardId: row.bankAccountId
            })
          });
          break;
        case 'f4':
          this.$router.push({
            path: `/applyLoan/${row.productId}/step4_bl`,
            query: Object.assign(query, {
              selectedBankcardId: row.bankAccountId
            })
          });
          break;
        default:
          this.$router.push({
            path: `/applyLoan/${row.productId}/step2_bl`,
            query
          });
          break;
      }
    },
    toLoanDelete(frontApplyId, itemApplyId) {
      this.frontApplyId = frontApplyId;
      this.itemApplyId = itemApplyId;
      this.isDeleteLoanItemFrontApply = true;
    },
    deleteLoanItem() { // 删除项目
      MyLoanApi.delFrontItem({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        frontApplyId: this.frontApplyId
      }).then((res) => {
        if (res.rspcode == 1) {
          this.isDeleteLoanItemFrontApply = false;
          this.factorinList();
          this.setSuccessMessage({
            show: true,
            content: '删除成功'
          });
        } else {
          this.setFailMessage({
            show: true,
            content: res.rspdesc || '删除失败'
          });
        }
      }).catch((error) => {

      });
    },
    getPage(currentPage) {
      //        if (currentPage === 1) {
      //          debugger
      //        } else {
      this.getPageCurrent({ pageCurrent: currentPage });
      this.$router.push({
        path: '/personalCenter/myloan_bl/loanLists_bl',
        query: {
          frontApplyState: this.frontApplyState,
          pageCurrent: this.pageCurrent
        }
      });
      //        }
    },

    //      分页调用
    changePage(currentPage) {
      this.pageNum = currentPage;
      this.getPageCurrent({ pageCurrent: currentPage });
      this.factorinList();
    },

    // 获取项目状态列表数据
    factorinList() {
      const _this = this;
      _this.states = this.$route.query.applyState;
      MyLoanApi.getItemApplyList({
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        applyState: _this.states || 'all',
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }).then((res) => {
        if (res.rspcode == 1) {
          _this.loanListData = res.data.frontApplyList;
          _this.frontApplyCount = res.data.frontApplyCount;
          _this.loanListData.forEach((item, index) => {
            const day = this.timestampToTime(item.applyDate);
            item.applyDate = day;
          });
        } else {

        }
        // 分页页码
        // var pageLength =res.data.frontApplyList.length;
        // for(var i = 0;i<pageLength;i++){
        //   _this.pageArr.push(i+1);
        // }
      }).catch((error) => {

      });
    },
    // 时间戳转日期
    timestampToTime(value) {
      const time = new Date(value);
      const year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      if (month <= 9) {
        month = `0${month}`;
      }
      if (day <= 9) {
        day = `0${day}`;
      }
      if (h <= 9) {
        h = `0${h}`;
      }
      if (mm <= 9) {
        mm = `0${mm}`;
      }
      return `${year}-${month}-${day}`;
    },
    // 编辑
    editor(index) {
      const _this = this;
      this.$nextTick(() => {
        _this.loanListData.forEach((t, i) => {
          if (index == i) {
            this.$router.push(`/applyLoan/${t.productId}/step2_bl`);
          }
        });
      });
    },
    // 删除

    deleteList(index) {
      const _this = this;
      this.$nextTick(() => {
        _this.loanListData.forEach((t, i) => {
          if (index == i) {
            MyLoanApi.delFrontItem({
              tokenId: localStorage.getItem('dl_tokenId_bl'),
              frontApplyId: t.frontApplyId
            }).then((res) => {
              if (res.rspcode) {
                this.factorinList();
              } else {

              }

              ;
            }).cache((error) => {

            });
            // _this.loanListData.splice(i,1);
          }
        });
      });
    },

    Hdev() {
      axios.get('');
    },
    // 千分号
    format(num) {
      const str = `${num}`;
      return str.split('').reverse().reduce((prev, next, index) => ((index % 3) ? next : (`${next},`)) + prev);
    },

    getMyBlItemInfoCountNew() { // hgwn 测试 9/12
      const _this = this;
      let state = '';
      if (this.$route.query.applyState) {
        state = this.$route.query.applyState;
      } else {
        state = 'all';
      }
      axios({
        url: '/loanform/blitem/blLoanItemFrontApply/getItemApplyListNew.ht',
        method: 'get',
        params: {
          tokenId: localStorage.getItem('dl_tokenId_bl'),
          applyState: state
        },
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        }
      }).then((res) => {
        if (res.data.rspcode == 1) {
          _this.loanListData = res.data.data.frontApplyList;
        }
      })
        .catch((error) => {

        });
    }

  },
  created() {
    this.setActiveName('all');
    this.factorinList('all');
  },
  mounted() {
    //       this.getMyBlItemInfoCountNew();
  },
  watch: {
    $route() {
      this.factorinList();  // 暂时注解 hgwn

      if (_.isEmpty(this.$route.query)) {

      } else if (this.$route.query.frontApplyState !== this.frontApplyState) {

      }
    }
  }
};
</script>
<style lang="scss">
.front-apply-money {
  color: #eb662b;
}

.loan-table {
  .el-tabs__active-bar {
    width: 0;
  }

  .el-button--mini {
    width: 44px;
    height: 22px;
    color: #fff;
    font-family: "FZLanTingHei-DB-GBK";
    background: #35c4f9;
    border: none;
  }

  .el-button:focus,
  .el-button:hover {
    color: #fff;
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #fff;
    background-color: #99a3a7;
  }

  .el-pager li.number {
    line-height: 19px;
    color: #a1a9ac;
    &.active {
      color: #21c2f9;
      border-color: transparent;
      background-color: transparent;
    }
  }

  .el-pagination {
    padding: 12px 0;
    button.disabled {
      color: #99a2a7;
    }
  }

  .el-table__body-wrapper {
    tr {
      position: relative;
      &:not(:first-child):after {
        content: "";
        position: absolute;
        left: 13px;
        height: 1px;
        width: 846px;
        background-color: #f6f6f6;
      }
    }
  }

  .table-body {
    box-sizing: border-box;
    border: none;

    &:before {
      display: none;
    }

    &:after {
      display: none;
    }

    td {
      /*border-bottom: 1px solid #F6F6F6;*/
      border-bottom: none;
    }

    th.is-leaf {
      border-bottom: none;
      overflow: hidden;
      height: 27px;
      background: none;
    }

    .cell {
      text-align: center;
      line-height: 59px;
      font-size: 14px;
      font-weight: bold;
    }

    th .cell {
      font-size: 12px;
      color: #cdd8dc;
      line-height: 27px;
      background: none;
    }

    .item_index {
      position: relative;
      display: inline-block;
      border-radius: 2px;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      color: $white;
      font-size: 12px;
      font-weight: normal;
      background: #cdd8dc;
    }
    .business_button {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      margin: 0 auto;
      border-radius: 4px;
      height: 20px;
      text-align: center;
      color: $white;
      font-size: 12px;
      font-weight: normal;
      background: rgb(179, 207, 218);
    }
  }
}

.disabled_btn {
  display: inline-block;
  width: 44px;
  height: 22px;
  margin: 0 5px;
  background: #99a3a7;
  font-size: 12px;
  border: none;
  border-radius: 3px;
  color: #fff;
  cursor: not-allowed;
  position: relative;
}
.list_btn {
  display: inline-block;
  width: 44px;
  height: 22px;
  margin: 0 5px;
  background: #99a3a7;
  font-size: 12px;
  border: none;
  border-radius: 3px;
  color: #fff;
  outline: none;
  cursor: pointer;
  position: relative;
  &:hover {
    background: #00c0ff;
  }
}
// 进度样式
.busineStep{
  margin: 0 auto;
  padding: 5px 0;
  padding-left: 14%;
}
.block {
  text-align: center;
  padding: 10px 0 30px 0;
  .page_num {
    width: 30px;
    line-height: 30px;
    background: #ccc;
    color: #fff;
    display: inline-block;
    text-align: center;
    font-size: 20px;
    margin: 0 10px;
    cursor: pointer;
    &:first-of-type {
      background: #00c0ff;
    }
    /*margin: 0 auto;*/
  }
}
.red-point-tip5 {
    position: absolute;
    top: 25px;
    left: 40px;
    background: #f00;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: inline-block;
    z-index: 1;
  }
.el-table .cell {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// LoanLists_bl.vue?cac13fde